export function MultiPlayCommissionPolicyService($http, $q, apexApiUrl) {
    'ngInject';
    const service = {
        retrieveMultiPlayCommissionPolicies: retrieveMultiPlayCommissionPolicies,
        retrieveMultiPlayCommissionPolicy: retrieveMultiPlayCommissionPolicy,
        createMultiPlayCommissionPolicy: createMultiPlayCommissionPolicy,
        updateMultiPlayCommissionPolicy: updateMultiPlayCommissionPolicy,
        deleteMultiPlayCommissionPolicy: deleteMultiPlayCommissionPolicy,
        duplicateMultiPlayCommissionPolicyExists: duplicateMultiPlayCommissionPolicyExists
    };

    return service;

    function retrieveMultiPlayCommissionPolicies(divisionID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "divisions/" + divisionID + "/multi-play-commission-policies",
            headers: {
                Accept: 'application/json'
            }
        }).then(function (response) {
            return response.data;
        })
    }

    function retrieveMultiPlayCommissionPolicy(multiPlayCommissionPolicyID) {
        return $http({
            method: "GET",
            url: apexApiUrl + "multi-play-commission-policies/" + multiPlayCommissionPolicyID,
            headers: {
                Accept: "application/json"
            }
        }).then(function (response) {
            return response.data;
        });
    }

    function createMultiPlayCommissionPolicy(multiPlayCommissionPolicy) {
        return $http({
            method: "POST",
            url: apexApiUrl + "multi-play-commission-policies",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: multiPlayCommissionPolicy
        }).then(function (response) {
            return response.data;
        });
    }

    function updateMultiPlayCommissionPolicy(multiPlayCommissionPolicyID, multiPlayCommissionPolicy) {
        return $http({
            method: "PUT",
            url: apexApiUrl + "multi-play-commission-policies/" + multiPlayCommissionPolicyID,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            },
            data: multiPlayCommissionPolicy
        })
    }

    function deleteMultiPlayCommissionPolicy(multiPlayCommissionPolicyID) {
        return $http({
            method: "DELETE",
            url: apexApiUrl + "multi-play-commission-policies/" + multiPlayCommissionPolicyID
        }).then(function (response) {
            return response.data;
        });
    }

    function duplicateMultiPlayCommissionPolicyExists(commissionPolicy, commissionPolicies) {
        let anyDuplicates = false;
        if (commissionPolicy.Product && commissionPolicy.ProductLine) {
            anyDuplicates = commissionPolicies.reduce(function (any, other) {
                return any || other !== commissionPolicy
                    && other.Product && other.Product.ProductID === commissionPolicy.Product.ProductID
                    && other.ProductLine
                    && other.ProductLine.ProductLineID === commissionPolicy.ProductLine.ProductLineID;
            }, false);
        }
        return anyDuplicates;
    }

}
